<template>
  <div class="team-arrival-live-location">
    <div class="full-container">
      <div class="top-navbar">
        <div class="row align-items-center">
          <div class="col-md-4">
            <div class="top-navbar-left">
              <div
                class="btn-back"
                @click="$router.push({ name: 'teamArrivalDetails' })"
              >
                <font-awesome-icon :icon="['fas', 'angle-left']" />
                Back
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="top-navbar-center">
              TL Live Location
            </div>
          </div>

          <div class="col-md-4">
            <!-- <div class="top-navbar-right">
                            <button class="btn btn-ecdc" @click="$router.push({ name: 'teamCreate' });">Create Team</button>
                        </div> -->
          </div>
        </div>
      </div>

      <hr />

      <div class="row">
        <div id="table-content-col" class="col-lg-7">
          <div
            class="table-options row justify-content-between align-items-center"
          >
            <!-- <div class="col-lg">
              <div class="table-search form-inline d-inline-block">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search by keyword"
                />
                <button type="button" class="btn btn-ecdc btn-circle">
                  <app-icon-search></app-icon-search>
                </button>
              </div>
            </div> -->

            <div class="col-lg">
              <app-paginate
                :page-count="totalPage"
                :click-handler="pagination"
                :prev-text="'&laquo;'"
                :next-text="'&raquo;'"
                ref="paginateTop"
                :container-class="'pagination justify-content-end'"
              >
              </app-paginate>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-striped table-hover result-table">
              <thead>
                <tr>
                  <th>Index</th>
                  <th>Division</th>
                  <th>Region</th>
                  <th>Area</th>
                  <th>Current Active TL</th>
                  <th class="text-center">ACTION</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(liveGps, index) in liveGpsData.result"
                  v-bind:key="liveGps.id"
                >
                  <td>{{ ++index }}</td>
                  <td>{{ liveGps.division_name }}</td>
                  <td>{{ liveGps.region_name }}</td>
                  <td>{{ liveGps.name }}</td>
                  <td>
                    <label class="badge live-badge" v-if="liveGps.live_tl_number > 0">
                      LIVE <span class="live-number">{{ liveGps.live_tl_number }}</span>
                    </label>
                  </td>
                  <td
                    class="text-center"
                    @click="
                      $router.push({
                        name: 'teamArrivalLiveLocationMap',
                        params: { area_id: liveGps.id },
                      })
                    "
                  >
                    <button class="btn btn-link btn-icon icon-right">
                      View
                      <font-awesome-icon
                        class="icon"
                        :icon="['fas', 'angle-right']"
                      />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="row justify-content-between table-options">
            <div class="col-lg">
              <select
                class="form-control custom-select"
                v-model="pageLimit"
                @change="pagination(1)"
              >
                <option value="15">15</option>
                <option value="30">30</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              per page
            </div>
            <div class="col-lg text-center">
              {{ showingResults }}
            </div>
            <div class="col-lg">
              <app-paginate
                :page-count="totalPage"
                :click-handler="pagination"
                :prev-text="'&laquo;'"
                :next-text="'&raquo;'"
                ref="paginateBottom"
                :container-class="'pagination justify-content-end'"
              >
              </app-paginate>
            </div>
          </div>
        </div>

        <div class="col-lg-5">
          <div id="cdcMap"></div>
        </div>
      </div>
    </div>

    <app-loader v-show="isLoading"></app-loader>
  </div>
</template>

<script>
import { teamLeaderLiveGPSs } from "../api";
import Loader from "./Loader.vue";
import Paginate from "vuejs-paginate";
// import IconSearch from "../svg/Search.vue";
import { getProj } from '../helpers/index'

export default {
  components: {
    appLoader: Loader,
    appPaginate: Paginate
    // appIconSearch: IconSearch,
  },
  data() {
    return {
      liveGpsData: {
        result: [],
      },
      isLoading: true,
      proj_id: "2",
      totalPage: 0,
      pageLimit: 15,
      showingResults: "",
      styledMapType: ""
    };
  },
  async mounted() {
    this.proj_id = getProj().projId;

    this.styledMapType = new window.google.maps.StyledMapType(
      JSON.parse(process.env.VUE_APP_MAP),
      { name: "Styled Map" }
    );
    await this.getTeamLeaderLiveGPSs(1);
    this.isLoading = false;
  },
  methods: {
    async getTeamLeaderLiveGPSs(pageNum) {
      try {
        const result = await teamLeaderLiveGPSs(
          { proj_id: this.proj_id },
          pageNum,
          this.pageLimit
        );
        this.liveGpsData = result.data.data;
        this.totalPage = this.liveGpsData.total / this.pageLimit;
        if (this.totalPage % 1 != 0)
          this.totalPage = parseInt(this.totalPage) + 1;
        else this.totalPage = parseInt(this.totalPage);

        var startPage = 1;

        if (pageNum != 1) startPage = this.pageLimit * (pageNum - 1) + 1;

        var endPage = pageNum * this.pageLimit;

        if (endPage >= this.liveGpsData.total) endPage = this.liveGpsData.total;

        this.showingResults =
          "Showing " +
          startPage +
          " - " +
          endPage +
          " of " +
          this.liveGpsData.total +
          " results";

        this.initMap();
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async pagination(pageNum) {
      this.isLoading = true;

      if (pageNum != 0)
        this.$refs.paginateTop.selected = this.$refs.paginateBottom.selected = pageNum;
      else pageNum = this.$refs.paginateBottom.selected;

      await this.getTeamLeaderLiveGPSs(pageNum);

      this.isLoading = false;
    },
    initMap() {

      const _this = this;
      const resultLiveGpsData = this.liveGpsData.result ? this.liveGpsData.result:[];
      let lat = "-6.1843548"
      let long = "106.7480016";

      if(resultLiveGpsData.length > 0) {
        for (let i = 0; i < resultLiveGpsData.length; i++) {
          if(resultLiveGpsData[i].lat_long_details.length > 0) {
            for (let j = 0; j < resultLiveGpsData[i].lat_long_details.length; j++) {
              if(resultLiveGpsData[i].lat_long_details[j].latitude != null && resultLiveGpsData[i].lat_long_details[j].longitude != null) { 
                lat = resultLiveGpsData[i].lat_long_details[j].latitude;
                long = resultLiveGpsData[i].lat_long_details[j].longitude;
                break;
              }
            }
            
            if(lat != "-6.1843548" && long != "106.7480016") {
              break;
            }
          }
        }
      }

      this.map = new window.google.maps.Map(document.getElementById("cdcMap"), {
        center: {
          lat: parseFloat(lat),
          lng: parseFloat(long),
        },
        scrollwheel: false,
        zoom: 6,
      });
      this.map.mapTypes.set("styled_map", this.styledMapType);
      this.map.setMapTypeId("styled_map");

      resultLiveGpsData.forEach(function (location) {
        if(location.lat_long_details.length > 0) {
          location.lat_long_details.forEach(function (latLong, index) {
            if (isNaN(latLong.latitude) || isNaN(latLong.longitude) || latLong.latitude == null || latLong.longitude == null) return;

            const template = _this.templateString(index);

            new window.google.maps.Marker({
              position: {
                lat: parseFloat(latLong.latitude),
                lng: parseFloat(latLong.longitude),
              },
              animation: window.google.maps.Animation.DROP,
              map: _this.map,
              icon: {
                url:
                  "data:image/svg+xml;charset=UTF-8," +
                  encodeURIComponent(template),
                scaledSize: new window.google.maps.Size(40, 40),
              },
              title: "LIVE",
            });     
          });
        }
      });
    },
    templateString(index) {
      return `<svg xmlns="http://www.w3.org/2000/svg" width="24.558" height="31.617" viewBox="0 0 24.558 31.617">\
        <g id="pin-yellow-sequence" transform="translate(-1318.569 -659.191)">\
        <g id="maps-and-flags" transform="translate(1261.418 659.191)">\
        <path id="Path_57" data-name="Path 57" d="M81.71,12.279c0,9.832-11.1,18.939-11.1,18.939a1.942,1.942,0,0,1-2.359,0s-11.1-9.106-11.1-18.939a12.279,12.279,0,0,1,24.559,0Z" fill="#fdcd08"/>\
        <path id="Path_58" data-name="Path 58" d="M165.417,117.721a9.458,9.458,0,1,1,9.458-9.458A9.468,9.468,0,0,1,165.417,117.721Z" transform="translate(-95.986 -95.984)" fill="#2b4162"/>\
        </g>\
        <text id="_1" data-name="1" transform="translate(1334 675.5)" fill="#fdcd08" font-size="12" font-family="Arial-BoldMT, Arial" font-weight="700" text-anchor="middle"><tspan x="-3.337" y="0">\
        ${index + 1}\
        </tspan></text>\
        </g>\
        </svg>`;
    }
  }
};
</script>

<style scoped>
#cdcMap {
  width: 100%;
  height: 550px;
}
</style>
